import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { AuthenticationService } from './auth.service';
import { Permiso } from '../interfaces/permiso';
import { Globals, MODULOS } from '../globals';
import { Permisos } from '../interfaces/permisos';

export interface LlamadoPermisoAction {
  componente: string; // componente que solicita el "controller/action" que debe ejecutar
  interval: any; // interval que se crea para responder a su llamado
}

@Injectable()
export class PermisoService {
  public permisos: Permiso[] = []; // permisos cargados para el usuario logueado
  permisosCargados: boolean = false; // true si ya hay permisos cargados
  intervalGetPermisosArray: LlamadoPermisoAction[] = []; // array con llamados a get action
  intervalTienePermisosArray: LlamadoPermisoAction[] = []; // array con llamados a tiene permiso
  SIN_PERMISO: string = "SIN_PERMISO"; // flag si no tiene permiso
  ROL_DIRECTOR: number = 3;
  ROL_ADMINISTRADOR: number = 1;
  ROL_VENDEDOR: number = 2;
  ROL_OPERARIO: number = 4;

  constructor(
    private authenticationService: AuthenticationService,
    private globals: Globals
  ) { }

  flushPermisos(): void {
    this.permisos = [];
  }

  // buscar en el listado de permisos el padre del permiso recibido
  getPermisoPadre(permiso: Permiso): Permiso {
    var permisoPadre = null;

    this.permisos.forEach(posiblePermisoPadre => {
      if (permiso.permisoIdPermisoPadre == posiblePermisoPadre.IdPermiso) { // si encontramos el padre
        permisoPadre = posiblePermisoPadre; // guardamos el padre
        return; // dejamos de recorrer, encontramos el padre
      }
    });

    return permisoPadre;
  }

  // genera el component tree, es decir,
  // para el componente recibido busca todos sus padres y padres de padres etc...
  getPermisoComponentTree(permiso: Permiso) {
    var componentTree = '';
    var permisoActual = permiso;

    var componentPadresPila: Permiso[] = [] // traer todos los padres del componente y guardarlos en una pila de permisos
    while (permisoActual.permisoIdPermisoPadre != null) { // mientras que exista un padre
      var permisoPadre = this.getPermisoPadre(permisoActual);
      componentPadresPila.push(permisoPadre); // guardar el padre en la pila
      permisoActual = permisoPadre;
    }

    // cuando ya tenemos la pila de padres cargada, generamos el component tree
    componentPadresPila.forEach(permisoPadre => {
      componentTree += permisoPadre.permisoComponente + '-';
    });

    return ((componentTree.length > 0) ? componentTree : '') + permiso.permisoComponente;
  }

  // formatea los permisos del servidor para poder usarlos en la libreria interna
  formatearPermisos(): string[] {
    var permisosReturn = null;

    if (this.permisos && this.permisos.length > 0) { // si tenemos permisos
      permisosReturn = [];
      this.permisos.forEach(permiso => { // para cada permiso generamos su arbol de permisos
        permisosReturn.push(this.getPermisoComponentTree(permiso));
      });
    }

    return permisosReturn;
  }

  // CARGAR PERMISOS DEL USUARIO LOGUEADO
  getPermisos(): Observable<any> {
    this.authenticationService.tipo = +this.authenticationService.tipo;

    this.permisosCargados = false;
    return new Observable((observer) => {
      setTimeout(() => {
        // listado de permisos asignados según el usuario
        let idsPermiso = [];
        idsPermiso = this.authenticationService.permisos.map(function (item) {
          return item;
        });

        observer.next({
          estado: 1,
          data: (new Permisos()).LISTADO.filter((permiso) => { return idsPermiso.includes(permiso.IdPermiso); })
        });
        observer.complete();
      }, 10);
    }).map((respuesta: any) => {
      if (respuesta.estado == 1 && respuesta.data) {
        this.flushPermisos();
        respuesta.data.forEach(permiso => {
          this.permisos.push(<Permiso>{ // guardar permisos tal cual llegan para el uso en el sistema
            IdPermiso: permiso.IdPermiso,
            permisoComponente: permiso.permisoComponente,
            permisoAction: permiso.permisoAction,
            permisoIdPermisoPadre: permiso.permisoIdPermisoPadre
          })
        });
      }

      this.permisosCargados = true;
      return this.formatearPermisos(); // retorna los permisos formateados para la libreria que adminsitra los permisos
    });
  }

  // true si tiene permiso, o false si no lo tiene
  // ademas si los permisos aún no se cargaron espera a que se carguen para verificar y retornar un valor
  tienePermiso(permisoComponente: string): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      this.intervalTienePermisosArray.push(
        <LlamadoPermisoAction>{ // siempre que los permisos aun no esten cargados, se consulta si ya fueron cargados cada un tiempo
          componente: permisoComponente,
          interval: this.intervalTienePermiso(resolve, permisoComponente)
        }
      );
    });
  }

  intervalTienePermiso(resolve: any, permisoComponente: string): any {
    if (this.permisosCargados) { // si los permisos estan cargados
      this.completarResolve(resolve, permisoComponente);

      return null;
    }

    return setInterval(() => { // si los permisos no estan cargados
      if (this.permisosCargados) { // si la busqueda detecta que se termino de buscar los permisos                        
        this.completarResolve(resolve, permisoComponente);

        // stop control, ya no es necesario seguir preguntando si los permisos fueron cargados
        this.cancelarPermisoInterval(this.intervalTienePermisosArray, permisoComponente);
      }
    }, 300);

  }

  // setear en el resolve los valores según corresponda
  completarResolve(resolve: any, permisoComponente: string): void {
      resolve(true);   
  }

  // retorma un observable que busca el "contorller/action" que se debe ejecutar en el servidor
  // como estas acciones se traen tambien del servidor retornara la accion adecuada
  // una vez que los permisos fueron cargados de manera asincrónica
  // si los permisos aún no fueron cargados, se quedara esperando la respuesta con el "interval"
  getPermisoAction(permisoComponente: string): Observable<string> {
    return new Observable(
      (observer) => {
        this.intervalGetPermisosArray.push(
          <LlamadoPermisoAction>{ // siempre que los permisos aun no esten cargados, se consulta si ya fueron cargados cada un tiempo
            componente: permisoComponente,
            interval: this.intervalControlPermisos(observer, permisoComponente)
          }
        );
      }
    );
  }

  // interval que controla si estan los permisos
  // si no estan pregunta cada un tiempo si ya estan hasta que esten
  // si los permisos ya estaban cargados retorna directamente los permisos cargados
  intervalControlPermisos(observer: any, permisoComponente: string): any {
    if (this.permisosCargados) { // si no estoy buscando permisos puedo retornarlos sin generar una busqueda
      // permisos encontrados sin necesisdad de controlar con un loop
      this.completarObserver(observer, permisoComponente);

      return null;
    }

    return setInterval(() => {
      if (this.permisosCargados) { // si la busqueda detecta que se termino de buscar los permisos
        // permisos encontrados mediante busqueda
        this.completarObserver(observer, permisoComponente);

        // stop control, ya no es necesario seguir preguntando si los permisos fueron cargados
        this.cancelarPermisoInterval(this.intervalGetPermisosArray, permisoComponente);
      }
    }, 300);
  }

  // setear en el observer los eventos y sus valores segun corresponda
  completarObserver(observer: any, permisoComponente: string): void {
    var controllerAction = this.permisoAction(permisoComponente);
    if (controllerAction != this.SIN_PERMISO) {
      observer.next(controllerAction); // retornar el "contorller/action" buscado para realizar la consulta al servidor
    } else {  // si no se encuentra el action asociado al componente
      observer.error('No hay un controller/action asociado a su permiso');

    }

    observer.complete(); // avisar al padre del observer que se completo la busqueda
  }

  cancelarPermisoInterval(arrayDeLlamados: LlamadoPermisoAction[], permisoComponente: string): void {  //  quitar de la cola de llamados la obtencion del permiso
    arrayDeLlamados.forEach((llamado: LlamadoPermisoAction) => {
      if (llamado.componente == permisoComponente) {
        clearInterval(llamado.interval);
        return; // llamado cancelado
      }
    });
  }

  permisoAction(permisoComponente: string): string { // retorna el "contorller/action" en el servidor según el componente que realiza el llamado
    var permisoAction = this.SIN_PERMISO;

    this.permisos.forEach(permiso => {
      if (permiso.permisoComponente == permisoComponente) {
        permisoAction = permiso.permisoAction;
        return true; // dejamos de recorrer, encontramos el action del permiso
      }
    });

    return permisoAction;
  }
}